import { FeatureFlagService, GID_NAMESPACE_GROUP, GitLabApiService, InstanceFeatureFlags, classifyDuoAccessError, ifVersionGte, isFetchError, toGitLabGid } from "@gitlab-org/core";
import { Logger, withPrefix } from "@gitlab-org/logging";
import { Injectable, createInterfaceId } from "@gitlab/needle";
import { DELETE_DUO_WORKFLOWS_WORKFLOW, GET_AGENT_FLOW_CONFIG, GET_CONFIGURED_AGENTS, GET_LATEST_CHECKPOINT_QUERY, GET_PROJECT_DATA, GET_USER_WORKFLOWS, GET_WORKFLOW_DEFINITION_QUERY, GET_WORKFLOW_ENABLEMENT_CHECKS_QUERY, GET_WORKFLOW_EVENTS_QUERY, GET_WORKFLOW_FLOW_IDENTITY_QUERY, WorkflowDefinition, defaultAgentPrivileges, resolveWorkflowDefinition } from "@gitlab-lsp/workflow-api";
import { GraphQLService, KnownGraphQLOperations } from "@gitlab-org/graphql";
import { Channel } from "@anycable/core";
import { gql } from "graphql-request";
import { isVirtualWorkspaceUri } from "@gitlab-org/fs";
//#region src/api/workflow_graphql_operations.ts
let _initClass$4;
function _applyDecs$4(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$4(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$4(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$4(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$4(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$4(t) {
	var i = _toPrimitive$4(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$4(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$4(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$4(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const WorkflowGraphqlOperations = createInterfaceId("WorkflowGraphqlOperations");
let _DefaultWorkflowGraph;
(class {
	static {
		[_DefaultWorkflowGraph, _initClass$4] = _applyDecs$4(this, [Injectable(WorkflowGraphqlOperations, [])], []).c;
	}
	#queries = [
		GET_PROJECT_DATA,
		GET_WORKFLOW_ENABLEMENT_CHECKS_QUERY,
		GET_WORKFLOW_EVENTS_QUERY,
		GET_USER_WORKFLOWS,
		DELETE_DUO_WORKFLOWS_WORKFLOW,
		GET_CONFIGURED_AGENTS,
		GET_AGENT_FLOW_CONFIG,
		GET_LATEST_CHECKPOINT_QUERY,
		GET_WORKFLOW_FLOW_IDENTITY_QUERY,
		GET_WORKFLOW_DEFINITION_QUERY
	];
	containsQuery(query) {
		return query !== null && this.#queries.includes(query);
	}
	static {
		_initClass$4();
	}
});
//#endregion
//#region src/api/errors.ts
var AgenticChatForbiddenError = class extends Error {
	constructor(message) {
		super(message);
		this.name = "AgenticChatForbiddenError";
	}
};
function isAgenticChatForbiddenError(error) {
	return error instanceof AgenticChatForbiddenError;
}
var NoDuoNamespaceError = class extends Error {
	constructor(message) {
		super(message);
		this.name = "NoDuoNamespaceError";
	}
};
function isNoDuoNamespaceError(error) {
	return error instanceof NoDuoNamespaceError;
}
function throwIfDuoAccessError(status, body) {
	const duoError = classifyDuoAccessError(status, body);
	if (!duoError) return;
	if (duoError.kind === "no_namespace") throw new NoDuoNamespaceError(duoError.message);
	throw new AgenticChatForbiddenError(duoError.message);
}
var DuoCliDisabledError = class extends Error {
	constructor(message) {
		super(message);
		this.name = "DuoCliDisabledError";
	}
};
function isDuoCliDisabledError(error) {
	return error instanceof DuoCliDisabledError;
}
//#endregion
//#region src/api/workflow_rails_service.ts
let _initClass$3;
function _applyDecs$3(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$3(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$3(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$3(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$3(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$3(t) {
	var i = _toPrimitive$3(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$3(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$3(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$3(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const WorkflowRailsService = createInterfaceId("WorkflowRailsService");
let _DefaultWorkflowRails;
(class {
	static {
		[_DefaultWorkflowRails, _initClass$3] = _applyDecs$3(this, [Injectable(WorkflowRailsService, [
			Logger,
			GitLabApiService,
			WorkflowGraphqlOperations,
			GraphQLService
		])], []).c;
	}
	#logger;
	#api;
	#agentPrivileges;
	#graphqlOperations;
	#graphqlService;
	#aiChatAvailableModelsResponse = null;
	#enabledFeatureFlags = null;
	#lastServerCapabilities = null;
	constructor(logger, gitlabApiService, graphqlOperations, graphqlService) {
		this.#logger = withPrefix(logger, "[WorkflowRailsService]");
		this.#api = gitlabApiService;
		this.#agentPrivileges = defaultAgentPrivileges;
		this.#graphqlOperations = graphqlOperations;
		this.#graphqlService = graphqlService;
		this.#api.onApiReconfigured(() => {
			this.#aiChatAvailableModelsResponse = null;
			this.#enabledFeatureFlags = null;
			this.#lastServerCapabilities = null;
		});
	}
	async updateStatus({ workflowId, statusEvent }) {
		return this.#api?.fetchFromApi({
			type: "rest",
			path: `/api/v4/ai/duo_workflows/workflows/${workflowId}`,
			method: "PATCH",
			body: { status_event: statusEvent }
		});
	}
	async sendEvent(workflowID, eventType, message) {
		if (!await this.#api?.fetchFromApi({
			type: "rest",
			method: "POST",
			path: `/api/v4/ai/duo_workflows/workflows/${workflowID}/events`,
			body: {
				event_type: eventType,
				...message || { message: "" }
			},
			supportedSinceInstanceVersion: {
				resourceName: "create a workflow event",
				version: "17.5.0"
			}
		})) throw new Error("Failed to create event");
	}
	setAgentPrivileges(agentPrivileges) {
		this.#agentPrivileges = agentPrivileges;
		this.#logger.info(`Updated agent privileges: ${agentPrivileges}`);
	}
	async createWorkflow(goal, containerParams, workflowDefinition, aiCatalogItemVersionId, additionalOptions = {}) {
		const allowAgentToRequestUser = additionalOptions?.allowAgentToRequestUser ?? true;
		const agentPrivileges = additionalOptions?.agentPrivileges ?? this.#agentPrivileges;
		const preApprovedAgentPrivileges = additionalOptions?.preApprovedAgentPrivileges ?? void 0;
		try {
			const basePayload = {
				...containerParams,
				goal,
				workflow_definition: resolveWorkflowDefinition(workflowDefinition),
				environment: "ide",
				allow_agent_to_request_user: allowAgentToRequestUser
			};
			const v176Additions = { agent_privileges: agentPrivileges };
			const v180Additions = {
				...v176Additions,
				pre_approved_agent_privileges: preApprovedAgentPrivileges
			};
			const v184Additions = {
				...v180Additions,
				ai_catalog_item_version_id: aiCatalogItemVersionId
			};
			const body = ifVersionGte(this.#api?.instanceInfo?.instanceVersion, "18.4.0", () => ({
				...basePayload,
				...v184Additions
			}), () => ifVersionGte(this.#api?.instanceInfo?.instanceVersion, "18.0.0", () => ({
				...basePayload,
				...v180Additions
			}), () => ifVersionGte(this.#api?.instanceInfo?.instanceVersion, "17.6.0", () => ({
				...basePayload,
				...v176Additions
			}), () => basePayload)));
			const response = await this.#api?.fetchFromApiRaw({
				type: "rest",
				method: "POST",
				path: "/api/v4/ai/duo_workflows/workflows",
				body,
				supportedSinceInstanceVersion: {
					resourceName: "create a workflow",
					version: "17.3.0"
				}
			});
			let responseData;
			try {
				responseData = await response.json();
			} catch {
				responseData = {};
			}
			if (!response.ok) this.#handleCreateWorkflowError(response, responseData);
			this.#parseFeatureFlags(response);
			if (responseData.id === null || responseData.id === void 0) {
				const errMessage = `An error occurred while creating the workflow. No workflow ID was returned from the API: ${responseData.message || responseData.error || ""}`;
				this.#logger.error(`${errMessage}. Response was: ${JSON.stringify(responseData)}`);
				throw new Error(errMessage);
			}
			return responseData.id.toString();
		} catch (e) {
			const error = e;
			this.#logger.error("Failed to create the workflow", error);
			throw e;
		}
	}
	async getWorkflowToken(workflowDefinition, rootNamespaceId, projectPath) {
		try {
			const body = {
				workflow_definition: resolveWorkflowDefinition(workflowDefinition),
				environment: "ide"
			};
			if (rootNamespaceId) body.root_namespace_id = rootNamespaceId;
			if (projectPath) body.project_id = projectPath;
			this.#logger.debug(`Requesting token with rootNamespaceId: ${rootNamespaceId ?? "undefined"}, projectPath: ${projectPath ?? "undefined"}`);
			const token = await this.#api?.fetchFromApi({
				type: "rest",
				method: "POST",
				path: "/api/v4/ai/duo_workflows/direct_access",
				body,
				supportedSinceInstanceVersion: {
					resourceName: "get workflow direct access",
					version: "18.1.0"
				}
			});
			this.#logServerCapabilitiesIfChanged(token.server_capabilities);
			return token;
		} catch (e) {
			const error = e;
			this.#logger.error("Failed to fetch the workflow token", error);
			if (isFetchError(e) && e.status === 403) throwIfDuoAccessError(e.status, e.body);
			throw e;
		}
	}
	buildAmbientWorkflowToken(serverCapabilities) {
		const token = this.#api?.tokenInfo?.token;
		const instanceUrl = this.#api?.instanceInfo?.instanceUrl;
		if (!token || !instanceUrl) throw new Error("Cannot build ambient workflow token: GitLab API service has no token/instance URL configured");
		this.#logger.debug("Reusing ambient GitLab API token for workflow execution; skipping /direct_access request");
		const farFutureMs = Date.now() + 1440 * 60 * 1e3;
		return {
			server_capabilities: serverCapabilities ?? void 0,
			gitlab_rails: {
				base_url: instanceUrl.toString(),
				token,
				token_expires_at: new Date(farFutureMs).toISOString()
			},
			duo_workflow_service: {
				base_url: "",
				token: "",
				secure: false,
				token_expires_at: Math.floor(farFutureMs / 1e3),
				headers: {}
			},
			isAmbientToken: true
		};
	}
	async revokeWorkflowToken(workflowToken) {
		if (workflowToken.isAmbientToken) {
			this.#logger.debug("Skipping workflow token revocation: token is the ambient GitLab API session token, not a minted workflow token.");
			return;
		}
		try {
			const instanceVersion = this.#api?.instanceInfo?.instanceVersion;
			const shouldUseNewEndpoint = instanceVersion && this.#isVersionGte(instanceVersion, "18.4.0");
			await this.#api?.fetchFromApi({
				type: "rest",
				method: "POST",
				path: shouldUseNewEndpoint ? "/api/v4/ai/duo_workflows/revoke_token" : "/oauth/revoke",
				body: { token: workflowToken.gitlab_rails.token },
				supportedSinceInstanceVersion: {
					resourceName: "revoke workflow token",
					version: shouldUseNewEndpoint ? "18.4.0" : "15.1.0"
				}
			});
			this.#logger.info("Successfully revoked workflow token");
		} catch (e) {
			const error = e;
			const wrappedError = /* @__PURE__ */ new Error("Could not revoke workflow token");
			wrappedError.cause = error;
			throw wrappedError;
		}
	}
	async getGraphqlData({ operationName, query, variables, supportedSinceInstanceVersion, fragment, signal }) {
		if (operationName) {
			const op = KnownGraphQLOperations[operationName];
			if (!op) throw new Error(`Unknown GraphQL operation: ${operationName}`);
			return this.#graphqlService.execute(op, variables, signal);
		}
		if (query) return this.#getGenericGraphqlData({
			query,
			variables,
			supportedSinceInstanceVersion,
			fragment,
			signal
		});
		throw new Error("Missing required argument either \"operationName\" or \"query\" must be provided.");
	}
	/**
	* @deprecated Declare an operation in the `lib_graphql` package instead.
	*/
	async #getGenericGraphqlData({ query, variables, supportedSinceInstanceVersion, fragment, signal }) {
		if (!this.#graphqlOperations.containsQuery(query)) {
			this.#logger.error(`: ${JSON.stringify({ query })}`);
			throw new Error("Provided Graphql query is not meeting performance standards.");
		}
		try {
			let addedFragment = "";
			if (fragment) {
				const { lt, gte, version } = fragment;
				addedFragment = ifVersionGte(this.#api?.instanceInfo?.instanceVersion, version, () => gte, () => lt);
			}
			return await this.#api?.fetchFromApi({
				type: "graphql",
				query: `${query}\n${addedFragment}`,
				variables: variables || {},
				supportedSinceInstanceVersion,
				signal
			});
		} catch (e) {
			this.#logger.info(`Graphql fetch failed:`, e);
			const error = e;
			this.#logger.error(error);
			throw new Error(error.message);
		}
	}
	async getAiChatAvailableModels({ rootNamespaceId }) {
		if (!rootNamespaceId) {
			this.#logger.debug("Skipping available model lookup: no namespace available.");
			return null;
		}
		if (!this.#aiChatAvailableModelsResponse) try {
			const variables = { rootNamespaceId: toGitLabGid(GID_NAMESPACE_GROUP, rootNamespaceId) };
			this.#aiChatAvailableModelsResponse = await this.getGraphqlData({
				query: null,
				operationName: "aiChatAvailableModels",
				variables
			});
		} catch (err) {
			this.#logger.warn("Unexpected exception fetching aiChatAvailableModels", err);
			this.#aiChatAvailableModelsResponse = null;
		}
		return this.#aiChatAvailableModelsResponse;
	}
	/**
	* Get the enabled feature flags.
	* Requires a workflowId to look up, but the feature flags are not workflow specific so we can cache the response
	*/
	async getEnabledWorkflowFeatureFlags(anyWorkflowId) {
		if (this.#enabledFeatureFlags) return this.#enabledFeatureFlags;
		try {
			const response = await this.#api?.fetchFromApiRaw({
				type: "rest",
				method: "HEAD",
				path: `/api/v4/ai/duo_workflows/workflows/${anyWorkflowId}`,
				supportedSinceInstanceVersion: {
					resourceName: "get workflow",
					version: "17.3.0"
				}
			});
			return this.#parseFeatureFlags(response);
		} catch (e) {
			const error = e;
			this.#logger.error("Failed to get enabled feature flags header", error);
			throw e;
		}
	}
	#parseFeatureFlags(response) {
		const headerValue = response.headers.get("x-gitlab-enabled-feature-flags");
		this.#enabledFeatureFlags = headerValue ? headerValue.split(",").filter(Boolean) : [];
		return this.#enabledFeatureFlags;
	}
	#logServerCapabilitiesIfChanged(capabilities) {
		const current = capabilities ? [...capabilities].sort() : [];
		const previous = this.#lastServerCapabilities;
		if (previous === null) if (!capabilities) this.#logger.warn("[Direct Access] No server_capabilities in response");
		else this.#logger.info(`[Direct Access] Server capabilities: [${current.join(", ")}]`);
		else if (current.length !== previous.length || current.some((cap, i) => cap !== previous[i])) this.#logger.info(`[Direct Access] Server capabilities changed: [${previous.join(", ")}] -> [${current.join(", ")}]`);
		this.#lastServerCapabilities = current;
	}
	#isVersionGte(current, minimumRequired) {
		return ifVersionGte(current, minimumRequired, () => true, () => false);
	}
	#handleCreateWorkflowError(response, responseData) {
		const responseMessage = typeof responseData === "object" && responseData !== null && "message" in responseData ? String(responseData.message) : "";
		if (response.status === 403 && responseMessage.toLowerCase().includes("duo cli has been disabled")) {
			this.#logger.error("Duo CLI is disabled by administrator");
			throw new DuoCliDisabledError(responseMessage);
		}
		if (response.status === 403) throwIfDuoAccessError(response.status, JSON.stringify(responseData));
		const errMessage = `Failed to create workflow: HTTP ${response.status}. ${responseMessage}`;
		this.#logger.error(`${errMessage}. Response was: ${JSON.stringify(responseData)}`);
		throw new Error(errMessage);
	}
	static {
		_initClass$3();
	}
});
//#endregion
//#region src/api/workflow_token_service.ts
let _initClass$2;
function _applyDecs$2(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$2(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$2(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$2(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$2(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$2(t) {
	var i = _toPrimitive$2(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$2(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$2(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$2(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const WorkflowTokenService = createInterfaceId("WorkflowTokenService");
const EXPIRY_BUFFER_MS = 30 * 1e3;
let _DefaultWorkflowToken;
(class {
	static {
		[_DefaultWorkflowToken, _initClass$2] = _applyDecs$2(this, [Injectable(WorkflowTokenService, [Logger, WorkflowRailsService])], []).c;
	}
	#logger;
	#workflowRailsService;
	#workflowTokens = /* @__PURE__ */ new Map();
	#CHAT_SHARED_TOKEN_KEY = "CHAT_SHARED_TOKEN";
	constructor(logger, workflowRailsService) {
		this.#logger = withPrefix(logger, "[WorkflowTokenService]");
		this.#workflowRailsService = workflowRailsService;
	}
	getTokenFromCache({ workflowDefinition, workflowId }) {
		const isChatWorkflow = workflowDefinition === WorkflowDefinition.CHAT;
		let key;
		if (isChatWorkflow) key = this.#CHAT_SHARED_TOKEN_KEY;
		else {
			if (!workflowId) return null;
			key = workflowId;
		}
		if (this.#workflowTokens.has(key)) {
			const { token } = this.#workflowTokens.get(key);
			return token;
		}
		return null;
	}
	getServerCapabilities({ workflowDefinition, workflowId }) {
		return this.getTokenFromCache({
			workflowDefinition,
			workflowId
		})?.server_capabilities || null;
	}
	async getToken(workflowId, workflowDefinition, rootNamespaceId, projectPath) {
		const cachedToken = this.getTokenFromCache({
			workflowDefinition,
			workflowId
		});
		if (cachedToken) {
			this.#logger.debug(`Reusing existing valid token for workflow "${workflowId}"`);
			return cachedToken;
		}
		this.#logger.debug(`Fetching new token for workflow "${workflowId}", definition: "${workflowDefinition}"`);
		const token = await this.#workflowRailsService.getWorkflowToken(workflowDefinition, rootNamespaceId, projectPath);
		this.cacheToken(workflowId, workflowDefinition, token);
		return token;
	}
	cacheToken(workflowId, workflowDefinition, token) {
		const key = workflowDefinition === WorkflowDefinition.CHAT ? this.#CHAT_SHARED_TOKEN_KEY : workflowId;
		const workflowTokenExpiresAt = this.#toMilliseconds(token.duo_workflow_service.token_expires_at);
		const railsTokenExpiresAt = this.#toMilliseconds(token.gitlab_rails.token_expires_at);
		const expiresAt = Math.min(workflowTokenExpiresAt, railsTokenExpiresAt);
		const timeoutDuration = Math.max(0, expiresAt - Date.now() - EXPIRY_BUFFER_MS);
		const timeoutId = setTimeout(() => {
			this.#logger.debug(`Token for workflow "${key}" is about to expire, clearing it`);
			this.#clearWorkflowToken(key);
		}, timeoutDuration);
		this.#workflowTokens.set(key, {
			token,
			timeoutId
		});
		this.#logger.debug(`Token for workflow "${key}" will expire at ${new Date(expiresAt).toISOString()}, clearing in ${timeoutDuration / 1e3} seconds`);
	}
	async revokeToken(workflowId, token) {
		try {
			this.#logger.debug("Revoking token");
			await this.#workflowRailsService.revokeWorkflowToken(token);
		} catch (err) {
			this.#logger.error("Error revoking token", err);
		} finally {
			const chatTokenInfo = this.#workflowTokens.get(this.#CHAT_SHARED_TOKEN_KEY);
			const key = chatTokenInfo && token === chatTokenInfo.token ? this.#CHAT_SHARED_TOKEN_KEY : workflowId;
			if (this.#workflowTokens.has(key)) {
				this.#clearWorkflowToken(key);
				this.#logger.debug(`Removed token for workflow "${key}" from cache`);
			}
		}
	}
	/**
	* Convert a token expiry value to ms. The workflow token seems to return ticks, while the rails token seems to return an iso string.
	* Normalise them both to ms
	*/
	#toMilliseconds(value) {
		if (typeof value === "number") return value * 1e3;
		if (typeof value === "string") {
			const date = new Date(value);
			if (Number.isNaN(date.getTime())) throw new Error(`Failed to parse token expiry date string: "${value}"`);
			return date.getTime();
		}
		throw new Error(`Received unexpected token expiry: "${value}"`);
	}
	#clearWorkflowToken(workflowId) {
		if (!this.#workflowTokens.has(workflowId)) return;
		const tokenInfo = this.#workflowTokens.get(workflowId);
		clearTimeout(tokenInfo.timeoutId);
		this.#workflowTokens.delete(workflowId);
	}
	dispose() {
		for (const workflowId of this.#workflowTokens.keys()) this.#clearWorkflowToken(workflowId);
		this.#logger.debug("Disposed token service, cleared all tokens and timeouts");
	}
	static {
		_initClass$2();
	}
});
//#endregion
//#region src/model_resolver_service.ts
let _initClass$1;
function _applyDecs$1(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$1(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$1(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$1(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$1(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$1(t) {
	var i = _toPrimitive$1(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$1(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$1(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const DEFAULT_MODEL_SENTINEL_PREFIX = "__default__";
const ModelResolverService = createInterfaceId("ModelResolverService");
let _DefaultModelResolver;
(class {
	static {
		[_DefaultModelResolver, _initClass$1] = _applyDecs$1(this, [Injectable(ModelResolverService, [
			WorkflowRailsService,
			FeatureFlagService,
			Logger
		])], []).c;
	}
	#workflowRailsService;
	#featureFlagService;
	#logger;
	constructor(workflowRailsService, featureFlagService, logger) {
		this.#workflowRailsService = workflowRailsService;
		this.#featureFlagService = featureFlagService;
		this.#logger = withPrefix(logger, "[ModelResolverService]");
	}
	async resolveModel(requestedModel, rootNamespaceId) {
		const response = await this.#workflowRailsService.getAiChatAvailableModels({ rootNamespaceId });
		const candidate = this.#selectCandidateModel(requestedModel, response?.aiChatAvailableModels);
		if (candidate?.startsWith(DEFAULT_MODEL_SENTINEL_PREFIX)) {
			this.#logger.debug(`Resolved model ref "${candidate}" is a "use the feature default" sentinel and will not be forwarded; the server will select the model for the active feature.`);
			return;
		}
		return candidate;
	}
	#selectCandidateModel(requestedModel, available) {
		const pinned = available?.pinnedModel?.ref;
		if (pinned) {
			if (requestedModel && requestedModel !== pinned) this.#logger.info(`Model selection overridden by pinned model: requested="${requestedModel}", using="${pinned}"`);
			else this.#logger.info(`Using pinned model: "${pinned}"`);
			return pinned;
		}
		if (!this.#featureFlagService.isInstanceFlagEnabled(InstanceFeatureFlags.UserModelSwitching)) {
			if (requestedModel) this.#logger.warn(`Model selection ignored: user model switching is disabled on this instance (requested="${requestedModel}")`);
			return;
		}
		const userSelected = available?.selectableModels.find((m) => m.ref === requestedModel)?.ref;
		if (userSelected) {
			this.#logger.info(`Using user-selected model: "${userSelected}"`);
			return userSelected;
		}
		if (requestedModel) {
			const selectableRefs = available?.selectableModels.map((m) => m.ref).filter((ref) => !ref.startsWith(DEFAULT_MODEL_SENTINEL_PREFIX)).join(", ");
			if (selectableRefs) this.#logger.debug(`Requested chat model "${requestedModel}" is not in the selectable set [${selectableRefs}]; the server will select the model for the active feature.`);
		}
		const defaultModel = available?.defaultModel?.ref;
		if (defaultModel) {
			this.#logger.info(`Using default model: "${defaultModel}"`);
			return defaultModel;
		}
		this.#logger.debug("No model selected on the client; the server will apply the default model configured for the active feature (expected for non-chat flows such as code review).");
	}
	static {
		_initClass$1();
	}
});
//#endregion
//#region src/api/graphql/workflow_events_response_channel.ts
const WORKFLOW_EVENTS_SUBSCRIPTION_QUERY = gql`
  subscription workflowEventsUpdated($workflowId: AiDuoWorkflowsWorkflowID!) {
    workflowEventsUpdated(workflowId: $workflowId) {
      checkpoint
      workflowStatus
      errors
      metadata
      workflowGoal
    }
  }
`;
var WorkflowEventsChannel = class extends Channel {
	static identifier = "GraphqlChannel";
	constructor(params) {
		super({
			channel: "GraphqlChannel",
			query: WORKFLOW_EVENTS_SUBSCRIPTION_QUERY,
			variables: JSON.stringify(params),
			operationName: "workflowEventsUpdated"
		});
	}
	receive(message) {
		if (!message.result.data.workflowEventsUpdated) return;
		const data = message.result.data.workflowEventsUpdated;
		this.emit("checkpoint", data);
	}
};
//#endregion
//#region src/api/workflow_command_service.ts
const USER_INTERRUPTED_COMMAND = "Command was interrupted by the user";
const COMMAND_TIMED_OUT_PREFIX = "Command timed out after";
const commandTimedOutMessage = (timeoutSeconds) => `${COMMAND_TIMED_OUT_PREFIX} ${timeoutSeconds}s`;
const isCommandTimedOut = (message) => message.startsWith(COMMAND_TIMED_OUT_PREFIX);
const isCommandError = (result) => {
	return Object.hasOwn(result, "error");
};
const WorkflowCommandService = createInterfaceId("WorkflowCommandService");
//#endregion
//#region src/code_insights/ranking/ranker_snippets.ts
const CodeSnippetRanker = createInterfaceId("CodeSnippetRanker");
//#endregion
//#region src/code_insights/ranking/bm25_snippets.ts
let _initClass;
function _applyDecs(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey(t) {
	var i = _toPrimitive(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
function countOccurrences(text, term) {
	if (!term) return 0;
	let count = 0;
	let pos = text.indexOf(term);
	while (pos !== -1) {
		count += 1;
		pos = text.indexOf(term, pos + term.length);
	}
	return count;
}
function normalizeQueryTerms(queryTerms) {
	const queryTermsFiltered = queryTerms.map((t) => t.trim().toLowerCase()).filter((t) => t.length > 0);
	return Array.from(new Set(queryTermsFiltered));
}
function computeIdf(queryTerms, snipFreq, totalSnippets) {
	const idf = {};
	for (const term of queryTerms) {
		const df = snipFreq[term] ?? 0;
		if (df === 0) idf[term] = 0;
		else idf[term] = Math.log(1 + (totalSnippets - df + .5) / (df + .5));
	}
	return idf;
}
function buildBM25Index(snippets, queryTerms) {
	const termFreqs = [];
	const snipLengths = [];
	const snipFreq = {};
	for (let i = 0; i < snippets.length; i += 1) {
		const snippet = snippets[i];
		if (snippet) {
			const text = snippet.lines.join("\n").toLowerCase();
			const tf = {};
			const seen = {};
			snipLengths[i] = text.length;
			for (const term of queryTerms) {
				const freq = countOccurrences(text, term);
				if (freq > 0) {
					tf[term] = freq;
					if (!seen[term]) {
						seen[term] = true;
						snipFreq[term] = (snipFreq[term] ?? 0) + 1;
					}
				}
			}
			termFreqs[i] = tf;
		}
	}
	return {
		termFreqs,
		snipLengths,
		snipFreq,
		inverseSnipFreq: computeIdf(queryTerms, snipFreq, snippets.length)
	};
}
function scoreSnippets(snippets, queryTerms, index, k1, b) {
	const totalSnippets = snippets.length;
	const avgdl = index.snipLengths.reduce((sum, dl) => sum + dl, 0) / totalSnippets;
	const scored = new Array(totalSnippets);
	const k1Plus1 = k1 + 1;
	const oneMinusB = 1 - b;
	for (let i = 0; i < totalSnippets; i++) {
		const tf = index.termFreqs[i];
		const dl = index.snipLengths[i];
		const snippet = snippets[i];
		if (tf && dl !== void 0 && snippet) {
			let score = 0;
			for (const term of queryTerms) {
				const freq = tf[term] ?? 0;
				if (freq > 0) {
					const termIdf = index.inverseSnipFreq[term] ?? 0;
					if (termIdf > 0) {
						const denom = freq + k1 * (oneMinusB + b * dl / avgdl);
						score += termIdf * (freq * k1Plus1 / denom);
					}
				}
			}
			scored[i] = [snippet, score];
		}
	}
	return scored;
}
function sortAndTrim(scored, topK) {
	scored.sort((a, b) => b[1] - a[1]);
	return scored.slice(0, topK);
}
/**
* BM25 ranking implementation for code snippets.
*
* Uses the Best Matching 25 (BM25) algorithm, a probabilistic ranking function
* commonly used in information retrieval. This implementation is optimized for
* ranking code snippets based on search terms.
*
* The algorithm considers:
* - Term frequency with saturation (controlled by k1 parameter).
* - Document length normalization (controlled by b parameter).
* - Inverse document frequency for term importance.
*
* BM25 is particularly well-suited for code search because it:
* - Handles exact matches (common in code) while still boosting repeated terms.
* - Normalizes for varying snippet lengths (single function vs entire class).
* - Uses IDF to prioritize distinctive terms over common keywords.
*
* @see {@link https://en.wikipedia.org/wiki/Okapi_BM25} BM25 Wikipedia
* @see Robertson & Zaragoza (2009) "The Probabilistic Relevance Framework: BM25 and Beyond"
* @see Robertson et al. (1995) "Okapi at TREC-3" - Original BM25 paper
*/
let _BM25CodeSnippetsRank;
(class {
	static {
		[_BM25CodeSnippetsRank, _initClass] = _applyDecs(this, [Injectable(CodeSnippetRanker, [])], []).c;
	}
	/**
	* Term frequency saturation parameter (k1).
	*
	* Controls how quickly term frequency saturates. Higher values mean term frequency
	* continues to have impact even at high frequencies, while lower values cause
	* diminishing returns more quickly.
	*
	* Standard range: 1.2 - 2.0
	* Default: 1.5 - provides good balance for code search where exact matches are common
	* but some repetition (like variable names) should still boost relevance.
	*/
	#k1 = 1.5;
	/**
	* Length normalization parameter (b).
	*
	* Controls document length normalization. b=0 means no length penalty, b=1 means
	* full length normalization (strongly favors shorter documents).
	*
	* Standard range: 0.0 - 1.0
	* Default: 0.75 - well-established default that provides moderate length penalty.
	* This works well for code snippets which can vary significantly in length
	* (single function vs entire class) while still allowing relevant longer snippets
	* to rank appropriately.
	*/
	#b = .75;
	async rank(snippets, queryTerms, topK) {
		if (snippets.length === 0) return [];
		const queryTermsNormalized = normalizeQueryTerms(queryTerms);
		if (queryTermsNormalized.length === 0) return [];
		const index = buildBM25Index(snippets, queryTermsNormalized);
		const scoredSnippets = scoreSnippets(snippets, queryTermsNormalized, index, this.#k1, this.#b);
		const withScore = scoredSnippets.filter((s) => s[1] > 0);
		const anyTermMatched = index.termFreqs.some((tf) => Object.keys(tf).length > 0);
		const rankedSnippets = sortAndTrim(withScore.length > 0 || !anyTermMatched ? withScore : scoredSnippets, topK);
		return Promise.resolve(rankedSnippets);
	}
	static {
		_initClass();
	}
});
//#endregion
//#region src/services/rg_binary_provider.ts
/**
* A string token representing the path to the embedded rg binary.
* Each binary (CLI, LS) registers this in DI by importing from its own
* auto-generated shim (rg_binary_embed.ts).
*/
const RgEmbeddedBinaryPath = createInterfaceId("RgEmbeddedBinaryPath");
const RgBinaryProvider = createInterfaceId("RgBinaryProvider");
//#endregion
//#region src/executors/action_executor_factory.ts
const ActionExecutorFactory = createInterfaceId("ActionExecutorFactory");
//#endregion
//#region src/executors/direct_action_executor.ts
var DirectActionExecutor = class {
	#handlers;
	#logger;
	constructor(handlers, logger) {
		this.#handlers = handlers;
		this.#logger = withPrefix(logger, "[DirectActionExecutor]");
	}
	async execute(action, context) {
		const handler = this.#handlers.find((h) => h.canHandle(action));
		if (!handler) {
			const actionKeys = Object.keys(action).filter((k) => k !== "requestID");
			this.#logger.warn(`No handler found for action: ${actionKeys.join(", ")}`);
			return {
				error: "action not supported",
				response: ""
			};
		}
		if (handler.supportsVirtualWorkspace === false && isVirtualWorkspaceUri(context.workspaceFolderUri)) {
			const error = `${handler.name} is not available for virtual filesystem workspaces.`;
			this.#logger.debug(error);
			return {
				error,
				response: ""
			};
		}
		return handler.execute(action, context);
	}
	dispose() {}
};
//#endregion
export { isAgenticChatForbiddenError as C, _DefaultWorkflowGraph as D, throwIfDuoAccessError as E, NoDuoNamespaceError as S, isNoDuoNamespaceError as T, _DefaultWorkflowToken as _, _BM25CodeSnippetsRank as a, AgenticChatForbiddenError as b, USER_INTERRUPTED_COMMAND as c, isCommandError as d, isCommandTimedOut as f, WorkflowTokenService as g, _DefaultModelResolver as h, RgEmbeddedBinaryPath as i, WorkflowCommandService as l, ModelResolverService as m, ActionExecutorFactory as n, CodeSnippetRanker as o, WorkflowEventsChannel as p, RgBinaryProvider as r, COMMAND_TIMED_OUT_PREFIX as s, DirectActionExecutor as t, commandTimedOutMessage as u, WorkflowRailsService as v, isDuoCliDisabledError as w, DuoCliDisabledError as x, _DefaultWorkflowRails as y };

//# sourceMappingURL=direct_action_executor-C20YagJV.mjs.map